var inScene = null;
var outScene = null;
var currentWindowWidth = null;
$(function () {
    // var gap = $('.section-1-3 .scrollable-content').innerWidth() - $(window).width();
    timelineScrollInit();
    // }
    let resizedFinished;
    $(window).on('resize', function() {
        clearTimeout(resizedFinished);
        resizedFinished = setTimeout(function(){
            if(currentWindowWidth !== $(this).width()) {
                currentWindowWidth = $(this).width();
                timelineScrollInit();
            }
        }, 250);
    });
});

// horizontal scroll tween
function timelineScrollInit() {
    // var windowWidth = $(window).width();
    if(inScene !== null){
        outScene.destroy(true);
        inScene.destroy(true);
    }

    if ($(window).width() > 992) {
        var gap = $('.section-1-3 .scrollable-content').innerWidth() - $(window).width() + $('.section-1-3 .main-text-col').innerWidth();
        var pinned = '.section-1-3 .pinned';
        // $('.section-1-1').height('650vh');
        // var pinned = '.section-1-3 .scrollable-content-container';
    } else {
        var gap = 0;
        $('.section-1-3 .scrollable-content .d-flex > div').each(function () {
            gap += $(this).width();
        });
        gap -= $(window).width();
        // var gap = $('.section-1-3 .scrollable-content').innerWidth();
        var pinned = '.section-1-3 .scrollable-content-container';
        // gap = 0;
    }

    if (gap > 0) {
        var section1_3Horizontal = new TimelineMax()
            .to(".section-1-3 .scrollable-content", 1, {
                x: "-" + gap + "px"
                // x: '-100%'
            })
        
        var durationPin = "475%";
        var durationHorizontal = "450%";
        durationPin = $(window).height()*4.75;
        durationHorizontal = $(window).height()*4.5;
        
        if($(window).width() > $(window).height()) {
            if ($(window).width() > 1024) {
                // durationPin = "550%";
                durationPin = $(window).height()*5;
            }
        }
        

        // create scene to pin and link animation
        inScene = new ScrollMagic.Scene({
            offset        : 0,
            triggerElement: pinned,
            triggerHook   : 0,
            duration      : durationPin
        })
            .setPin(pinned)
            .addTo(require('../scrollInit'));
        // create scene to pin and link animation

        outScene = new ScrollMagic.Scene({
            offset        : 0,
            triggerElement: pinned,
            triggerHook   : 0,
            duration      : durationHorizontal
        })
            .setTween(section1_3Horizontal)
            .addTo(require('../scrollInit'));
    }

    AOS.refresh();
}